<mat-icon>{{value}}</mat-icon>